import * as React from 'react';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { SexEnum } from '../../../models';
import { useTranslations } from '../../../store/translations/hooks';

export interface SexFieldProps {
    value: SexEnum,
    id?: string,
    label?: string,
    disabled?: boolean,
    onChange: (value: SexEnum) => void,
}

export const SexField = (props: SexFieldProps) => {
    const {
        value,
        id,
        label,
        disabled,
        onChange,
    } = props;

    const t = useTranslations() as (key:string) => string;
    const parse = (sex: string) => SexEnum[sex as keyof typeof SexEnum];

    const labelId = label && id ? `${id}-label` : undefined;

    return (
        <FormControl fullWidth size="small">
            {label && <InputLabel id={labelId}>{label}</InputLabel>}
            <Select
                id={id ? `${id}-input` : undefined}
                labelId={labelId}
                disabled={disabled}
                value={SexEnum[value]}
                label={label}
                onChange={e => onChange(parse(e.target.value))}
                variant="outlined"
            >
                {
                    Object.values(SexEnum)
                        .filter(p => typeof p === 'string')
                        .map(p => p as string)
                        .map(k => (
                            <MenuItem
                                id={id ? `${id}-option-${k}` : undefined}
                                key={k}
                                value={k}
                            >
                                {t(k.toLowerCase())}
                            </MenuItem>
                        ))
                }
            </Select>
        </FormControl>
    );
}
